import React from "react";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";

const Banner = () => {
  return (
    <div id="about" className="w-full py-[30px] bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <section className="overflow-hidden rounded-3xl shadow-xl bg-white flex flex-col md:flex-row border border-gray-100">
          {/* Image container with improved overlay */}
          <div className="relative md:w-5/12 h-72 md:h-auto overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/40 via-yellow-400/30 to-transparent z-10"></div>
            <img
              alt="Electrical cables"
              src="https://www.endesa.com/content/dam/endesa-com/endesaclientes/blog/imagenes/tipos-cables1248x616.jpg"
              className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
            />
            <div className="absolute bottom-0 left-0 bg-yellow-500 text-white py-2 px-4 rounded-tr-lg font-medium z-20">
              Premium keyfiyyət
            </div>
          </div>

          {/* Content container */}
          <div className="p-6 md:p-10 lg:p-12 md:w-7/12 flex flex-col justify-center">
            <div className="max-w-xl">
              <span className="inline-block px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-sm font-medium mb-4">
                Kabelmarket.az
              </span>
              
              <h2 className="font-bold text-3xl sm:text-4xl lg:text-5xl text-gray-800 leading-tight">
                Elektrik kabellərinin rahat alışının <span className="text-yellow-500">tək ünvanı</span>
              </h2>

              <p className="mt-5 text-base md:text-lg text-gray-600">
                Hər növ kabellərin satışı. Yüksək keyfiyyət, sərfəli qiymətlər və sürətli çatdırılma.
              </p>

              <div className="mt-8 space-y-4 sm:space-y-0 flex flex-col sm:flex-row gap-4">
                <a
                  className="group inline-flex items-center justify-center px-6 py-3.5 rounded-xl bg-yellow-500 hover:bg-yellow-600 transition-all text-white font-medium text-base shadow-md hover:shadow-lg"
                  href="/allproducts"
                >
                  Bütün məhsullar
                  <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </a>

                <a
                  className="group inline-flex items-center justify-center px-6 py-3.5 rounded-xl bg-white border border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-all text-gray-800 font-medium text-base"
                  href="#contact"
                >
                  <FaPhoneAlt className="mr-2 text-yellow-500" />
                  Bizimlə əlaqə
                </a>
              </div>
              
              <div className="mt-8 pt-6 border-t border-gray-100 grid grid-cols-2 md:grid-cols-3 gap-4">
                <div className="flex flex-col">
                  <span className="text-2xl font-bold text-yellow-500">20+</span>
                  <span className="text-gray-600 text-sm">İl təcrübə</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-2xl font-bold text-yellow-500">1000+</span>
                  <span className="text-gray-600 text-sm">Razı müştəri</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-2xl font-bold text-yellow-500">100%</span>
                  <span className="text-gray-600 text-sm">Keyfiyyət zəmanəti</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Banner;
